//64位控件的calssid
let classidx64="clsid:A64E3073-2016-4baf-A89D-FFE1FAA10EF2";
//32位控件的classid
let classid="clsid:A64E3073-2016-4baf-A89D-FFE1FAA10ED2";
//谷歌和火狐的classid
let chfixclassid="{A64E3073-2016-4baf-A89D-FFE1FAA10ED2}";
//32位控件包的路径
let codebase="/bid/3/ntko/officecontrol/ofctnewclsid.cab#version=6,0,1,0";
//64位控件包的路径
let codebase64="/bid/3/ntko/officecontrol/ofctnewclsidx64.cab#version=6,0,1,0";
//买断授权密钥如果不是买断可以不用写
let MakerCaption="广东翼迅信息科技有限公司";
//买断授权密钥如果不是买断可以不用写
let MakerKey="52832C11D939E44F5A89C68C8EEF5B03B90A9E74";
//密钥
let ProductCaption="广东志正招标有限公司";
//密钥
let ProductKey="C244E1183488C6CD78339ADAE0B0B4AFEA797A6C"

//解除时间密钥
let NoExpireKey="";

export default {
    classidx64: function(){
        return classidx64
    },
    classid: function(){
        return classid
    },
    chfixclassid: function(){
        return chfixclassid
    },
    codebase: function(){
        return codebase
    },
    codebase64: function(){
        return codebase64
    },
    MakerCaption: function(){
        return MakerCaption
    },
    MakerKey: function(){
        return MakerKey
    },
    ProductCaption: function(){
        return ProductCaption
    },
    ProductKey: function(){
        return ProductKey
    },
    NoExpireKey: function(){
        return NoExpireKey
    }
}
